import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./VisualizzaQuadro.css";
import { FaPencilAlt, FaDownload } from "react-icons/fa";
import { jsPDF } from "jspdf";
import JsBarcode from "jsbarcode";

function VisualizzaQuadro() {
    const GENERE_OPTIONS = [
        "Horror", "Anime", "Cinema", "Videogiochi", "Musica",
        "Pop Art", "Sport", "Japan", "Classic Art"
    ];

    const DIMENSIONI_OPTIONS = [
        "15X20", "16X16", "10X45", "25X25", "25X35", "20X50",
        "20X60", "20X70", "20X80", "20X110", "30X60", "36X60",
        "60X80", "40X120"
    ];

    const [quadri, setQuadri] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedGenere, setSelectedGenere] = useState("");
    const [selectedDimensione, setSelectedDimensione] = useState("");

    const [showPopup, setShowPopup] = useState(false);
    const [selectedQuadro, setSelectedQuadro] = useState(null);

    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteStep, setDeleteStep] = useState(1);
    const [quadroToDelete, setQuadroToDelete] = useState(null);

    const [formData, setFormData] = useState({
        titolo: "",
        dimensione: "",
        quantita: "",
        percentualeVendita: "",
        genere: "",
        bn: false,
        sandy: false,
    });

    const navigate = useNavigate();
    const BASE_URL = "https://gestionaleideahome.com";

    // CARICA QUADRI
    useEffect(() => {
        axios
            .get("/api/quadri")
            .then((res) => setQuadri(res.data))
            .catch((err) => console.error("Errore nel recupero quadri:", err));
    }, []);

    const handleBack = () => navigate("/home");

    const getColorByPercentage = (percentage) => {
        if (percentage <= 19) return "green";
        if (percentage <= 29) return "blue";
        if (percentage <= 49) return "gold";
        if (percentage <= 100) return "red";
        return "black";
    };

    const filteredQuadri = quadri.filter((quadro) => {
        const matchSearch = (quadro.titolo || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase());

        const matchGenere = selectedGenere ? quadro.genere === selectedGenere : true;
        const matchDimensione = selectedDimensione ? quadro.dimensione === selectedDimensione : true;

        return matchSearch && matchGenere && matchDimensione;
    });

    const resetFilters = () => {
        setSearchTerm("");
        setSelectedGenere("");
        setSelectedDimensione("");
    };

    const handleEditClick = (quadro) => {
        setSelectedQuadro(quadro);
        setFormData({
            titolo: quadro.titolo || "",
            dimensione: quadro.dimensione || "",
            quantita: quadro.quantita ?? "",
            percentualeVendita: quadro.percentualeVendita ?? "",
            genere: quadro.genere || "",
            bn: Boolean(quadro.bn),
            sandy: Boolean(quadro.sandy),
        });
        setShowPopup(true);
    };

    const closePopup = () => {
        setShowPopup(false);
        setSelectedQuadro(null);
    };

    const handleSave = async () => {
        try {
            const payload = {
                titolo: formData.titolo,
                genere: formData.genere,
                dimensione: formData.dimensione,
                quantita: Number(formData.quantita),
                percentualeVendita: Number(formData.percentualeVendita),
                bn: formData.bn,
                sandy: formData.sandy,
            };

            await axios.put(`/api/quadri/${selectedQuadro._id}`, payload);

            const res = await axios.get("/api/quadri");
            setQuadri(res.data);

            closePopup();
        } catch (err) {
            console.error("Errore aggiornamento:", err);
            alert("Si è verificato un errore durante il salvataggio.");
        }
    };

    // 🔥 ELIMINA QUADRO
    const handleDelete = async () => {
        if (!quadroToDelete) return;

        try {
            const res = await axios.delete(`/api/quadri/${quadroToDelete._id}`);

            if (res.data.success) {
                setQuadri(prev => prev.filter(q => q._id !== quadroToDelete._id));
            } else {
                alert("Errore: " + res.data.message);
            }
        } catch (err) {
            console.error(err);
            alert("Errore durante l'eliminazione");
        }

        setShowDeletePopup(false);
        setQuadroToDelete(null);
        setDeleteStep(1);
    };

    const handleDownload = (quadro) => {
        try {
            const valoreBarcode = quadro.codiceBarre;
            if (!valoreBarcode) {
                alert("Codice a barre non disponibile. Salva il quadro prima di stamparlo.");
                return;
            }

            const canvas = document.createElement("canvas");
            JsBarcode(canvas, valoreBarcode, {
                format: "CODE128",
                width: 2,
                height: 30,
                displayValue: false,
                margin: 10,
            });

            const barcodeImage = canvas.toDataURL("image/png");

            const pdf = new jsPDF({
                unit: "mm",
                format: [60, 30],
                orientation: "landscape",
            });

            pdf.addImage(barcodeImage, "PNG", 5, 3, 50, 15);

            let y = 21;
            pdf.setFontSize(6);

            const titoloCompatto = (quadro.titolo || "-").slice(0, 22);
            pdf.text(`Tit: ${titoloCompatto}`, 3, y);
            y += 3;

            pdf.text(
                `Dim: ${quadro.dimensione || "-"}   Gen: ${quadro.genere || "-"}`,
                3,
                y
            );

            const safeTitle = (quadro.titolo || "quadro").replace(/[^a-z0-9]/gi, "_");
            pdf.save(`${safeTitle}_etichetta.pdf`);
        } catch (err) {
            console.error("Errore generazione PDF:", err);
            alert("Errore nella generazione del PDF.");
        }
    };

    // 🔥 POPUP ELIMINAZIONE (POSIZIONE CORRETTA)
    const deletePopup = showDeletePopup && (
        <div className="popup-overlay">
            <div className="popup delete-popup">

                {deleteStep === 1 && (
                    <>
                        <h3>Sei sicuro di voler eliminare questo quadro?</h3>
                        <div className="popup_actions">
                            <button className="save_btn" onClick={() => setDeleteStep(2)}>
                                Sì
                            </button>
                            <button
                                className="close_btn"
                                onClick={() => {
                                    setShowDeletePopup(false);
                                    setDeleteStep(1);
                                    setQuadroToDelete(null);
                                }}
                            >
                                No
                            </button>
                        </div>
                    </>
                )}

                {deleteStep === 2 && (
                    <>
                        <h3>Cliccando su Conferma il quadro verrà eliminato.</h3>
                        <div className="popup_actions">
                            <button className="save_btn" onClick={handleDelete}>
                                Conferma
                            </button>
                            <button
                                className="close_btn"
                                onClick={() => {
                                    setShowDeletePopup(false);
                                    setDeleteStep(1);
                                    setQuadroToDelete(null);
                                }}
                            >
                                Annulla
                            </button>
                        </div>
                    </>
                )}

            </div>
        </div>
    );

    return (
        <div id="container">

            {deletePopup}

            <div id="nav_bar">
                <div id="logo_container">
                    <img id="logo_title" src={"logo-header.png"} alt="Logo" />
                </div>

                <div id="title">
                    <p>Visualizza Quadri</p>
                </div>

                <div id="back_button">
                    <button id="back" onClick={handleBack}>Torna indietro</button>
                </div>
            </div>

            <div id="filters">
                <input
                    type="text"
                    placeholder="Cerca per titolo..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />

                <select
                    value={selectedGenere}
                    onChange={(e) => setSelectedGenere(e.target.value)}
                >
                    <option value="">Tutti i generi</option>
                    {GENERE_OPTIONS.map((g) => (
                        <option key={g} value={g}>{g}</option>
                    ))}
                </select>

                <select
                    value={selectedDimensione}
                    onChange={(e) => setSelectedDimensione(e.target.value)}
                >
                    <option value="">Tutte le dimensioni</option>
                    {DIMENSIONI_OPTIONS.map((d) => (
                        <option key={d} value={d}>{d}</option>
                    ))}
                </select>

                <button id="reset" onClick={resetFilters}>Reset Filtri</button>
            </div>

            {/* 🔥 CARD CONTAINER */}
            <div id="card_container">
                {filteredQuadri.map((quadro) => (
                    <div className="card" key={quadro._id}>

                        {/* ❌ Bottone elimina */}
                        <button
                            className="delete-btn"
                            onClick={() => {
                                setQuadroToDelete(quadro);
                                setDeleteStep(1);
                                setShowDeletePopup(true);
                            }}
                        >
                            ×
                        </button>

                        {quadro.immagine && (
                            <img
                                src={`${BASE_URL}${quadro.immagine}`}
                                alt={quadro.titolo}
                                className="card_image"
                            />
                        )}

                        <div className="desc_card">
                            <p><strong>Nome:</strong> {quadro.titolo}</p>
                            <p><strong>Genere:</strong> {quadro.genere}</p>
                            <p><strong>Dimensione:</strong> {quadro.dimensione}</p>

                            <p
                                style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    color: getColorByPercentage(quadro.percentualeVendita),
                                }}
                            >
                                <strong>Quantità:</strong> {quadro.quantita} ({quadro.percentualeVendita}%)
                            </p>
                        </div>

                        <div className="card_actions">
                            <div
                                className="circle_button pink_button"
                                onClick={() => handleEditClick(quadro)}
                                title="Modifica"
                            >
                                <FaPencilAlt />
                            </div>

                            <div
                                className="circle_button pink_button"
                                onClick={() => handleDownload(quadro)}
                                title="Download"
                            >
                                <FaDownload />
                            </div>
                        </div>

                    </div>
                ))}
            </div>

            {/* POPUP MODIFICA */}
            {showPopup && selectedQuadro && (
                <div className="popup-overlay">
                    <div className="popup">
                        <button className="close_btn" onClick={closePopup}>✕</button>

                        <div className="popup_content">
                            <div className="popup_left">
                                {selectedQuadro.immagine && (
                                    <img
                                        src={`${BASE_URL}${selectedQuadro.immagine}`}
                                        alt={selectedQuadro.titolo}
                                        className="card_image"
                                    />
                                )}
                            </div>

                            <div className="popup_right">
                                <label>Titolo:</label>
                                <input
                                    type="text"
                                    value={formData.titolo}
                                    onChange={(e) =>
                                        setFormData({ ...formData, titolo: e.target.value })
                                    }
                                />

                                <label>Genere:</label>
                                <select
                                    value={formData.genere}
                                    onChange={(e) =>
                                        setFormData({ ...formData, genere: e.target.value })
                                    }
                                >
                                    <option value="">Seleziona genere</option>
                                    {GENERE_OPTIONS.map((g) => (
                                        <option key={g} value={g}>{g}</option>
                                    ))}
                                </select>

                                <label>Dimensione:</label>
                                <select
                                    value={formData.dimensione}
                                    onChange={(e) =>
                                        setFormData({ ...formData, dimensione: e.target.value })
                                    }
                                >
                                    <option value="">Seleziona dimensione</option>
                                    {DIMENSIONI_OPTIONS.map((d) => (
                                        <option key={d} value={d}>{d}</option>
                                    ))}
                                </select>

                                <div className="checkbox_group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={formData.bn}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    bn: e.target.checked,
                                                    sandy: e.target.checked ? false : formData.sandy,
                                                })
                                            }
                                        />
                                        BN
                                    </label>

                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={formData.sandy}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    sandy: e.target.checked,
                                                    bn: e.target.checked ? false : formData.bn,
                                                })
                                            }
                                        />
                                        S
                                    </label>
                                </div>

                                <label>Quantità:</label>
                                <input
                                    type="number"
                                    value={formData.quantita}
                                    onChange={(e) =>
                                        setFormData({ ...formData, quantita: e.target.value })
                                    }
                                />

                                <label>Percentuale vendita:</label>
                                <input
                                    type="number"
                                    value={formData.percentualeVendita}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            percentualeVendita: e.target.value,
                                        })
                                    }
                                />

                                <div className="popup_actions">
                                    <button className="save_btn" onClick={handleSave}>
                                        Salva modifiche
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )}

        </div>
    );
}

export default VisualizzaQuadro;
